import { AnnotationsMarker } from './AnnotationsMarker';
import MarkerDragSource from './MarkerDragSource';

export type AnnotationsCanvasMarkerProps = {
  index: number;
  position: number[];
  editing: boolean;
  onMouseOver?: () => void;
  onMouseOut?: () => void;
  onClick?: () => void;
  focus: boolean;
  blur: boolean;
};

export const AnnotationsCanvasMarker = ({
  position,
  index,
  editing,
  onMouseOver,
  onMouseOut,
  onClick,
  focus,
  blur,
}: AnnotationsCanvasMarkerProps) => (
  <MarkerDragSource
    id={index}
    left={position[0]}
    top={position[1]}
    canDrag={editing}
    onMouseOver={onMouseOver}
    onMouseOut={onMouseOut}
    onClick={onClick}
    focus={focus}
    blur={blur}
  >
    <AnnotationsMarker label={`${index + 1}`} />
  </MarkerDragSource>
);
